var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"flex-1 w-full max-w-5xl justify-start mx-auto flex flex-col bg-white"},[(_vm.lang == 'it')?_c('home-page-it'):_vm._e(),_vm._v(" "),(_vm.lang == 'en')?_c('home-page-en'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }